import Config from '@/thirdParty/config'

export default {
  methods: {
    // checkCreatedDateNganluong(date) {
    //   if (!date) return false
    //   return Number(date) > Config.nganluongSignThresholdDate
    // },
    checkCreatedDateNganluong(data) {
      if (
        !data ||
        data?.isNganluongContract === undefined ||
        data?.isNganluongContract === null ||
        data?.isNganluongContract === ''
      )
        return false
      return data.isNganluongContract === true
    },
    getIndex(index) {
      const limmit =
        this.search.limit ??
        this.search.pagination?.limmit ??
        this.search.size ??
        this.search.pagination?.size ??
        this.search.pageSize
      const page = (this.search.page ?? this.search.pagination?.page ?? this.search.pageIndex) - 1
      return limmit * page + index + 1
    },
  },
}
